import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { HomePage } from './pages/HomePage'
import { Phase2DetailPage } from './pages/Phase2DetailPage'
import { AllocationHelpPage } from './pages/AllocationHelpPage'
import { Layout } from './components/Layout'
import { CheckAllocationPage } from './pages/CheckAllocationPage'
import { ToastProvider, useToast } from './lib/useToast'
import { Toast } from './components/Toast'

function AppContent() {
  const { toast, hideToast } = useToast()

  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/phase2-detail" element={<Phase2DetailPage />} />
          <Route path="/allocation-help" element={<AllocationHelpPage />} />
          <Route path="/check-allocation" element={<CheckAllocationPage />} />
        </Routes>
      </Layout>
      
      {/* 全局 Toast */}
      <Toast 
        type={toast.type}
        title={toast.title}
        message={toast.message}
        isVisible={toast.isVisible}
        onClose={hideToast}
        autoClose={true}
        autoCloseDelay={4000}
      />
    </Router>
  )
}

function App() {
  return (
    <ToastProvider>
      <AppContent />
    </ToastProvider>
  )
}

export default App 